import * as d3 from "d3";
import {colonAnnotation, inrFormatter, responsivefy} from '../functions'

export default function (chart, divId, vizName, resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = resData
        var renameKeys = function (obj) {

            obj.name = obj.key;
            delete obj.key;
            if (obj.values) {
                obj.children = obj.values;
                delete obj.values;
                obj.children.forEach(renameKeys);
            }
            return obj;
        };

        var nest = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim3_name;
            }).sortKeys(d3.ascending)
            // .rollup(function (v) { return d3.sum(v, function (d) { return d.metric1; }) })
            .rollup(function (v) {
                return {
                    sum: d3.sum(v, function (d) {
                        return d.metric2;
                    }),
                    pct: d3.sum(v, function (d) {
                        return d.metric1;
                    })
                }
            })
            .entries(data);

        let nest1 = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            }).sortKeys(d3.ascending)
            .rollup(function (v) {
                return {
                    sum: d3.sum(v, function (d) {
                        return d.metric2;
                    }),
                    pct: d3.sum(v, function (d) {
                        return d.metric1;
                    })
                }
            })
            .entries(data)
            .map(function (d) {
                return {
                    name: d.key,
                    total_sum: d.value ? d.value.sum : 0,
                    total_pct: d.value ? d.value.pct : 0
                }
            })

        console.log("Nested Data", nest, nest1)


        // console.log("nestmult")
        /*The visualization requires there to be a root node*/
        var flareData = {key: chart.x1AxisDisplayName, values: []};
        flareData.values = nest;
        console.log("Flare Data", flareData)
        renameKeys(flareData);
        // let param = 'interpolateGreens' //comming from DB/API

        const colors = d3.interpolateGreens
        const colorsInn = d3.interpolateGreens

        let myScale = d3.scaleLinear()
            .domain(d3.extent(data, (d) => {
                return d.metric1;
            })) //-2 is the min possible value in data set, 20 is the max
            .range([0, 1]); //map to this range i.e -2 will become 0, 20 become 1,
                            //10 will become .5

        let myScaleInner = d3.scaleLinear()
            .domain(d3.extent(nest1, (d) => {
                return d.total_pct;
            }))//-3 is the min possible value in data set, 33 is the max
            .range([0, 1]);
        console.log("Min max value for metric1", d3.extent(data, (d) => {
            return d.metric1;
        }))

        function myColor(val) {

            let dim3 = data.find(d => d.dim3_name === val.data.name)
            let dim2 = data.find(d => d.dim2_name === val.data.name)
            let x;
            let c;
            let w;
            if (dim3) {
                //dim3
                x = dim3.metric1
                c = colors(myScale(x))
                w = '~out'
            } else {
                //dim2
                x = data.filter(d => d.dim2_name === val.data.name)
                    .map(d => d.metric1)
                    .reduce((a, b) => a + b, 0)

                c = colorsInn(myScaleInner(x))
                w = '~in'
            }

            console.log('color for ', val.data.name, w, x, c)
            if (x === 0 && !dim3 && !dim2) return 'gray' //for center circle
            return c
        }

        function m2tooltip(v) {
            let val;
            if (v.height == 0) {
                val = v.data.value.pct
            } else if (v.height == 1) {
                val = d3.sum(v.children, function (d) {
                    return d.data.value.pct;
                });
            } else if (v.height == 2) {
                val = d3.sum(v.children, function (d) {
                    return d3.sum(d.children, function (e) {
                        return e.data.value.pct
                    })
                });
            }
            console.log("m2 tooltip value", val)
            return inrFormatter(val)
        }

        (function visualize(dataset) {
            var graph = d3.hierarchy(flareData).sum((d) => {
                return d.value ? d.value.sum : 0
            })
            var nodes = flatten(graph);
            console.log("nodes", nodes)
            var links = graph.links();
            var i = 0

            console.warn(i, dataset)

            var svg = d3.select(divId).select("svg").remove();

            svg = d3.select(divId).append("svg")
                .attr("class", "scroll")
                .attr("width", chart.width)
                .attr("height", chart.height)
                .call(responsivefy)
                .append("g")

            //    var colorMetric ;
            //                    switch(true) {
            //                        case chart.vizSpecific5 == 'singleblue': {
            //                            colorMetric = 'd3.schemeBlues[5]'
            //                            break;
            //                        }
            //                        case chart.vizSpecific5 == 'singlered': {
            //                            colorMetric = 'd3.schemeReds[5]'
            //                            break;
            //                        }
            //                    }
            // //   var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way)
            //
            //   console.log("colorMetric",colorMetric)

            //   var metric1ColorScale = d3.scaleLinear(d3.schemeBlues[5])
            // //  .range(d3.schemeBlues)
            //   .domain([d3.min(nodes, (d) =>{ return d.value }),
            //       d3.max(nodes, (d) =>{ return d.value })]);


            // var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way)


            //  var radius = d3.scaleSqrt().range([0, 6]);

            var radius = d3.scaleSqrt()
                .domain([d3.min(nodes, function (d) {
                    return d.value
                }),
                    d3.max(nodes, function (d) {
                        return d.value
                    })])
                .range([11, 70]);


            var simulation = d3.forceSimulation()
                .force("link",
                    d3.forceLink().id(function (d) {
                        return d.name;
                    })
                        .distance(150)
                        .strength(function () {
                            return 2;
                        })
                )
                .force("charge", d3.forceManyBody().strength(-300))
                .force("collide", d3.forceCollide().radius(function (d) {
                    return radius(d.value / 2) + 5;
                }))
                .force("center", d3.forceCenter(chart.width / 3, chart.height / 3));

            var link = svg.append("g")
                .attr("class", "links")
                .selectAll("path")
                .data(links)
                .enter().append("svg:path")
                .attr("stroke-width", function () {
                    return 3
                });

            link.style('fill', 'none').style('stroke', 'black').style("stroke-width", '2px');

            /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var tip = tooltip_class()

            tip.attr('class', 'd3-tip'+divId.id)
               .html((d) =>{ return chart.y1MetricTooltip+ colonAnnotation+ inrFormatter(d.value) + "("+ chart.x2AxisDisplayName + ")" })

            svg.call(tip)*/

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            var node = svg.append("g")
                .attr("class", "nodes-mis")
                .selectAll("g")
                .data(nodes)
                .enter().append("g")
                .style('transform-origin', '50% 50%')
                .call(d3.drag()
                    .on("start", dragstarted)
                    .on("drag", dragged)
                    .on("end", dragended)
                )
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.y1MetricTooltip + colonAnnotation + inrFormatter(d.value) +
                        "<br>" +
                        chart.y2MetricTooltip + colonAnnotation + m2tooltip(d))
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", tip.show)
            //.on("mouseout", tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding


            node.append('circle')
                .attr("r", (d) => {
                    return radius(d.value);
                })
                .style('fill', (d) => {
                    return myColor(d)
                })
                .style("stroke", "black")
                .style("stroke-width", "1.5px")

            node.append("text")
                .attr("dy", ".35em")
                .attr("text-anchor", "middle")
                .text(function (d) {
                    return d.data.name;
                });

            simulation.nodes(nodes).on("tick", ticked);
            simulation.force("link").links(links);

            function ticked() {
                link.attr("d", function (d) {
                    var dx = d.target.x - d.source.x,
                        dy = d.target.y - d.source.y,
                        dr = Math.sqrt(dx * dx + dy * dy);
                    return (
                        "M" +
                        d.source.x +
                        "," +
                        d.source.y +
                        "A" +
                        dr +
                        "," +
                        dr +
                        " 0 0,1 " +
                        d.target.x +
                        "," +
                        d.target.y
                    );
                });

                node.attr("transform", function (d) {
                    return "translate(" + d.x + "," + d.y + ")";
                });
            }

            function dragstarted(d) {
                if (!d3.event.active) simulation.alphaTarget(0.3).restart();
                d.fx = d.x;
                d.fy = d.y;
            }

            function dragged(d) {
                d.fx = d3.event.x;
                d.fy = d3.event.y;
            }

            function dragended(d) {
                if (!d3.event.active) simulation.alphaTarget(0);
                d.fx = null;
                d.fy = null;
            }

            function flatten(root) {
                // hierarchical data to flat data for force layout
                var nodes = [];

                function recurse(node) {
                    if (node.children) node.children.forEach(recurse);
                    if (!node.id) node.id = ++i;
                    else ++i;
                    nodes.push(node);
                }

                recurse(root);
                return nodes;
            }
        })(flareData)
    // })//end of data function
}
